<script>
import { mapGetters } from 'vuex'
export default
{
    name: 'mv-main-page-images-form',

    computed: {
      ...mapGetters({
          artists: 'artistList',
      })
    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

        setArtist(artist)
        {
          if (artist && artist.id)
          {
            this.model.artist = artist
            this.model.artist_id = artist.id
          } else {
            this.model.artist = null
            this.model.artist_id = null
          }
        }

    },

    mounted()
    {
        this.$store.dispatch('artistCheck')
    },

    props:
    {
        model: Object,
        edit: Boolean,
    }

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('POST.TITLE') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.title" required>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.TEXT') }}
            </label>
            <div class="col-md-6">
                <textarea type="text" class="form-control" v-model="model.body" required>
                </textarea>
            </div>
        </div>

        <div class="form-group row">
            <label for="order" class="col-md-4 control-label">
                {{ $t('MENUS.ORDER') }}
            </label>
            <div class="col-md-6">
                <input type="number" class="form-control" v-model="model.order" >
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('ARTIST.ARTIST') }}
            </label>
            <div class="col-md-6">
                <v-select :options="artists" :value="model.artist" label="name" @input="setArtist($event)">
                    <template slot="option" slot-scope="option">
                        <div class="row option-row">
                            <div class="col-sm-2 hidden-sm hidden-xs">
                                <div v-if="option.attachments && option.attachments.length">
                                    <img :src="option.attachments[0].thumbnail_url">
                                </div>
                            </div>
                            <div class="col-sm-10">
                                <div class="text">
                                    {{ option.name }}
                                </div>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.IMAGES') }}
            </label>
            <div class="col-md-6">
                <mv-image-uploader ref="uploader" multiple @upload-done="addFile($event)" accept="image/*"></mv-image-uploader>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">

            </div>
            <div class="col-md-6">
                <mv-attachment v-for="img in model.attachments" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                </mv-attachment>
            </div>
        </div>

    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/MainPageImagesForm.vue